
<!-- Navbar -->

<div class="nav-container box-shadow-lower fixed-top">
  <div class="topbar">
    <div class="topbar-elements">
      <span>(+40)000 000000</span>
      <span *ngIf="!isLogged"><a routerLink='/registration'>Sign Up</a></span>
      <span *ngIf="!isLogged"><a routerLink='/login'>Log in</a></span>
      <span *ngIf="isLogged"><a (click)="logout()">Log Out</a></span>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg navbar-light bg-white logo-bar">
    <div class="container-fluid justify-content-lg-center">
        <a class= "navbar-brand a-link" (click)="navTo('home')"><img class="logo-top d-inline-block align-text-top mg-2" width="130px" src="assets/img/emdr official.svg" alt="EMDR therapy logo"/></a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse flex-lg-grow-0" id="navbarSupportedContent">
        <ul class="navbar-nav">  
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo('home')">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo('therapy')">EMDR Therapy</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo('help')">Professional Help</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo('faqs')">FAQs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="navTo('contact')">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>

<div class="home-body">

  <!-- Instructions -->
  <div class="body-container">
      <div class="body-background">
          <div class="body">
              <h3 class="title">Welcome To Your EMDR Therapy Session</h3>
              <p class="description">You are about to engage in an online therapy session, please take your time to answer all of the questions our conversational agent will present you. </p>
              <h3 class="title2">Read and follow the next instructions for an improved experience:</h3>

              <div class="instruction-box">
                <div class="box-number">1</div>
                <div class="box-text">Find a quiet room in which you feel comfortable. Make sure there are no distractions</div>
              </div>

              <div class="instruction-box">
                <div class="box-number">2</div>
                <div class="box-text">Try to be as honest as possible, be aware of your emotions and take your time to process them.</div>
              </div>

              <div class="instruction-box">
                <div class="box-number">3</div>
                <div class="box-text">Focus on what you are feeling when you remember the traumatic experience ,both physically and emotionally.</div>
              </div>

              <div class="instruction-box">
                <div class="box-number">4</div>
                <div class="box-text">The Conversational Agent will guide you through your therapy session.</div>
              </div>

              <div class="instruction-box">
                <div class="box-number">5</div>
                <div class="box-text">You will be redirected to your therapy session page as you progress through the questions</div>
              </div>

              <p class="description2">When the session begins, try to focus on the ball while managing your feelings. You will have to do this twice. The first time you will process the traumatic event. The second time you will imagine a pleasant memory to replace the traumatic one.</p>

              <div matRipple><button routerLink='/therapy' class="start-button" mat-raised-button color="#20BEA7">Begin Session</button></div>
              <div matRipple><button (click)="openChat()" class="start-button-tablet" mat-raised-button color="#20BEA7">Open Chat</button></div>

          </div>
      </div>
  </div>

  <!-- Chat -->

  <div class="chat-container">
    <div class="chat-topbar"><p class="chat-title">ChatBot</p></div>  
    <div id="message-container" #chatMessages>

      <div class="chat-row" *ngFor="let message of messages">

        <div *ngIf="message.sender=='user'" class="chat-bubble chat-bubble-right">
          {{message.message}}
          <span class="chat-bubble-corner chat-bubble-corner-right"></span>
        </div>

        <div *ngIf="message.sender=='bot'" class="chat-bubble chat-bubble-left">
          {{message.message}}
          <span class="chat-bubble-corner chat-bubble-corner-left"></span>
        </div>

        <div class="chat-divider"></div>

      </div>
      
    </div>


    <form (ngSubmit)="sendMessage()" class="message-bar">
      <input id="input" placeholder="Type something here..." autocomplete="off" [disabled]="isDisabled" [(ngModel)]="message" name="message"/>
      <button id="send"><span class="material-icons">
        send
      </span></button>
    </form>
  </div>  

</div>

<div class="chat-overlay" [ngStyle]="chatExpanded ? {'height': '100%'} : {'height':'0px'}">
  <div class="chat-topbar">
    <p class="chat-title">ChatBot</p>
    <button class='close-chat' (click)="closeChat()"><span class="material-icons">close</span></button>
  </div>  
  <div id="message-container" #chatMessages>

    <div class="chat-row" *ngFor="let message of messages">

      <div *ngIf="message.sender=='user'" class="chat-bubble chat-bubble-right">
        {{message.message}}
        <span class="chat-bubble-corner chat-bubble-corner-right"></span>
      </div>

      <div *ngIf="message.sender=='bot'" class="chat-bubble chat-bubble-left">
        {{message.message}}
        <span class="chat-bubble-corner chat-bubble-corner-left"></span>
      </div>

      <div class="chat-divider"></div>

    </div>
    
  </div>


  <form (ngSubmit)="sendMessage()" class="message-bar">
    <input id="input" placeholder="Type something here..." autocomplete="off" [disabled]="isDisabled" [(ngModel)]="message" name="message"/>
    <button id="send"><span class="material-icons">
      send
    </span></button>
  </form>
</div>